<section class="page-stack">
  <div class="page-heading">
    <div>
      <span class="eyebrow">Resumen operativo</span>
      <h2>Panel Helipagos</h2>
    </div>
  </div>

  <div class="metric-grid">
    <a class="metric-card" *ngFor="let item of auth.allowedNavigationItems" [routerLink]="item.path">
      <span class="metric-icon" [ngClass]="item.color">{{ item.icon }}</span>
      <div>
        <strong>{{ item.label }}</strong>
        <p>{{ item.description }}</p>
      </div>
    </a>
  </div>

  <div class="panel">
    <div class="panel-header">
      <div>
        <span class="eyebrow">Sesion</span>
        <h3>Informacion de acceso</h3>
      </div>
    </div>
    <div class="detail-grid">
      <div><span>Email</span><strong>{{ auth.userEmail }}</strong></div>
      <div><span>Grupos</span><strong>{{ auth.groups.join(', ') || 'Sin grupos' }}</strong></div>
      <div><span>Backend esperado</span><strong>http://localhost:8080</strong></div>
    </div>
  </div>
</section>
